import { api } from './BaseApi'
import {
  IBuffetGeneralReport,
  IBuffetGeneralReportChartData,
  IBuffetGeneralReportChartRequest,
  IBuffetGeneralReportRequest,
  IBiAnalyticsUrlDto,
} from './dto/BuffetGeneralReportDto'
import {
  IBuffetReportListDto,
  IBuffetReportRequest,
} from './dto/BuffetReportDto'
import { createQueryStringSmart } from 'utils/createQueryString'

export const buffetReportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBuffetReport: builder.query<IBuffetReportListDto, IBuffetReportRequest>({
      query: (params) => ({
        url: '/report_buffet/',
        params: !!params ? params : {},
      }),
      providesTags: ['BuffetReport'],
    }),
    getBuffetGeneralReport: builder.query<
      IBuffetGeneralReport,
      IBuffetGeneralReportRequest
    >({
      query: (params) => ({
        url: `/report_buffet/general_report/${createQueryStringSmart(params)}`,
      }),
      providesTags: ['BuffetReport'],
    }),
    getBuffetGeneralReportChart: builder.query<
      IBuffetGeneralReportChartData,
      IBuffetGeneralReportChartRequest
    >({
      query: (params) => ({
        url: '/report_buffet/general_report_chart_data/',
        params: !!params ? params : {},
      }),
      providesTags: ['BuffetReport'],
    }),
    getBiAnalyticsUrl: builder.query<IBiAnalyticsUrlDto, void>({
      query: () => ({
        url: '/bi_analytics/get_url_bi/',
      }),
      providesTags: ['BuffetReport'],
    }),
  }),
})

export const {
  useGetBuffetReportQuery,
  useGetBuffetGeneralReportQuery,
  useGetBuffetGeneralReportChartQuery,
  useGetBiAnalyticsUrlQuery,
  useLazyGetBiAnalyticsUrlQuery,
} = buffetReportApi
